import {
    Soup, Wheat, Beef, Fish, Milk, Salad, Droplet, Candy, Coffee,
    CookingPot, Sandwich, Utensils, Package, FlaskConical,
    Pizza, Croissant, Carrot, Egg, Cookie, Cake, Apple, Cherry,
    Grape, Drumstick, Popcorn, CupSoda, Beer, Wine, Nut, Banana,
    IceCreamCone, Flame,
} from 'lucide-react';
import { getKatVisual } from './receptUtils';

// Registr ikon — jediný zdroj pravdy pro seznam i pickery.
export const ICON_MAP = {
    soup: Soup, wheat: Wheat, beef: Beef, fish: Fish, milk: Milk,
    salad: Salad, droplet: Droplet, candy: Candy, coffee: Coffee,
    cookingpot: CookingPot, sandwich: Sandwich, utensils: Utensils, package: Package,
    flask: FlaskConical, pizza: Pizza, croissant: Croissant, carrot: Carrot,
    egg: Egg, cookie: Cookie, cake: Cake, apple: Apple, cherry: Cherry,
    grape: Grape, drumstick: Drumstick, popcorn: Popcorn, cupsoda: CupSoda,
    beer: Beer, wine: Wine, nut: Nut, banana: Banana, icecream: IceCreamCone, flame: Flame,
};
export const ICON_KEYS = Object.keys(ICON_MAP);

// Miniatura položky/kategorie: foto > vlastní ikona > ikona odvozená z kategorie.
//
// `slozka` = dlaždice kategorie: SYTÁ výplň s bílou ikonou. Položky (recepty)
// mají tlumenou průhlednou dlaždici — díky tomu jde na první pohled poznat,
// co je složka a co produkt. Dřív kreslily obě totéž a nedaly se rozlišit.
export default function RecipeKatIcon({ foto, ikona, kategorieNazev, kategorieBarva, size = 36, radius = 9, slozka = false }) {
    if (foto) {
        // Formáty s alfa kanálem bereme jako průhledné: podložka i zaoblení by
        // kolem loga udělaly rámeček, který tam nepatří, a `cover` by ho ořízl.
        // Fotky (JPEG) zůstávají v dlaždici a vyplní ji jako dřív.
        const pruhledny = /\.(png|webp|gif)(\?|$)/i.test(foto);
        return (
            <div style={{
                width: size, height: size, flexShrink: 0, overflow: 'hidden',
                borderRadius: pruhledny ? 0 : radius,
                background: pruhledny ? 'transparent' : 'rgba(0,0,0,0.06)',
            }}>
                <img src={foto.startsWith('http') || foto.startsWith('/') ? foto : `/storage/${foto}`}
                    alt="" loading="lazy"
                    style={{ width: '100%', height: '100%', objectFit: pruhledny ? 'contain' : 'cover', display: 'block' }} />
            </div>
        );
    }

    const { iconKey, color } = getKatVisual(kategorieNazev, kategorieBarva);
    const Icon = ICON_MAP[ikona] || ICON_MAP[iconKey] || FlaskConical;

    return (
        <div style={{
            width: size, height: size, borderRadius: radius, flexShrink: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: slozka ? color : `${color}1F`,
            border: `1px solid ${slozka ? color : color + '33'}`,
            boxShadow: slozka ? `0 1px 3px ${color}55` : 'none',
        }}>
            <Icon size={Math.round(size * 0.5)} style={{ color: slozka ? '#fff' : color }} />
        </div>
    );
}
